import Vuex from 'vuex';
import Vue from 'vue';
import http from '../http';
import main from '../main';
Vue.use(Vuex);
Vue.use(http);

const store = new Vuex.Store({
    state: {
        loginStatus: null, // 管理登录状态
        token: null, // 管理登录者信息
        rememberStatus: null, // 管理登录状态
        select: {},
        treeDefault: '', //树的默认选项
        userinfoChange: null, //修改用户信息
        treeChangeState: null // 树的冻结状态改变
    },
    mutations: {
        setLoginStatus(state, data) {
            state.loginStatus = data;
            sessionStorage.setItem('setLoginStatus', JSON.stringify(data));
        },
        setRememberStatus(state, data) {
            state.rememberStatus = data;
            sessionStorage.setItem('rememberStatus', JSON.stringify(data));
        },
        setToken(state, data) {
            state.token = data;
            sessionStorage.setItem('token', JSON.stringify(data));
        },
        setSelect(state, payload) {
            state.select[payload.code] = payload.data;
            state.select = { ...state.select };
        },
        setTreeData(state, data) {
            // 修改默认树
            state.treeDefault = data;
        },
        setTableQuery(state, data) {
            state.tableQuery = data;
        },
        changeUserInfo(state, data) {
            state.userinfoChange = data;
        },
        treeChange(state, data) {
            state.treeChangeState = data;
        }
    },
    actions: {
        getSelect(context, arr) {
            arr.forEach(e => {
                if (!context.state.select[e]) {
                    main.$http
                        .post(main.$service.main.code, {
                            categoryCode: e
                        })
                        .then(res => {
                            context.commit('setSelect', { code: e, data: res.data });
                        });
                }
            });
        }
    },
    getters: {
        getLoginStatus(state) {
            const cache = sessionStorage.getItem('setLoginStatus');
            const cacheData = cache ? JSON.parse(cache) : null;
            return state.loginStatus !== null ? state.loginStatus : cacheData;
        },
        getRememberStatus(state) {
            const cache = sessionStorage.getItem('rememberStatus');
            const cacheData = cache ? JSON.parse(cache) : null;
            return state.rememberStatus !== null ? state.rememberStatus : cacheData;
        },
        getToken(state) {
            const cache = sessionStorage.getItem('token');
            const cacheData = cache || null;
            return state.token || cacheData;
        },
        getSelectData: (state, getters) => code => {
            return state.select[code] || [];
        },
        getSelectDataName: (state, getters) => (code, value) => {
            const data = state.select[code] || [];
            for (let i = 0; i < data.length; i++) {
                if (data[i].value === value) {
                    return data[i].label;
                }
            }
        },
        getTreeData: state => {
            return state.treeDefault;
        },
        getChangeUser: state => {
            return state.userinfoChange;
        },
        getTreeChange: state => {
            return state.treeChangeState;
        }
    }
});

export default store;
